













































































































import { computed, defineComponent, toRefs } from '~/utils/nuxt3-migration'
import { timeDistanceFromNow } from '~/utils/date'
import { differenceInMinutes } from 'date-fns'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { ciCredit } from '~/icons/source/solid/credit'
import { useNamespacedStore } from '~/compositions/store'
import { PromotedTier } from '~/models/classified/promoted'
import PromoRibbon from '~/components/car/classifieds/promote/PromoRibbon.vue'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'

export default defineComponent({
  components: { PromoRibbon, CBadge },
  props: {
    promoTier: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    static: {
      type: Boolean,
      required: false,
      default: false
    },
    preferredPayment: {
      type: String,
      required: false,
      default: 'credits'
    }
  },
  setup(props) {
    const { promoTier, preferredPayment } = toRefs(props)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const paidCredits = computed(() => {
      return userGetters('paidCredits')
    })

    const costString = computed(() =>
      preferredPayment.value === 'stripe'
        ? `<strong>${promoTier.value.costEuro} €</strong>`
        : `<strong>${promoTier.value.cost}</strong> credits`
    )

    const expiresIn = computed(() => {
      if (promoTier.value.expires) {
        return timeDistanceFromNow(promoTier.value.expires, {
          addSuffix: false
        })
      }
      return null
    })

    const tierBadgeClasses = computed(() => {
      if (promoTier.value.tier === PromotedTier.TURBO) {
        return 'tw-fill-promote-turbo'
      } else if (promoTier.value.tier === PromotedTier.SUPER) {
        return 'tw-fill-promote-super'
      }
      return 'tw-fill-promote-top'
    })

    const tierTextClass = computed(() => {
      if (promoTier.value.tier === PromotedTier.TURBO) {
        return 'tw-text-promote-turbo'
      } else if (promoTier.value.tier === PromotedTier.SUPER) {
        return 'tw-text-green-500'
      }

      return 'tw-text-blue-600'
    })

    const tierBgClass = computed(() => {
      if (promoTier.value.tier === PromotedTier.TURBO) {
        return 'tw-bg-promote-turbo'
      } else if (promoTier.value.tier === PromotedTier.TOP) {
        return 'tw-bg-blue-600'
      }
      return 'tw-bg-green-500'
    })

    const expirePercentage = computed(() => {
      if (promoTier.value.expires && promoTier.value.tierDays) {
        const days = promoTier.value.tierDays
        const totalMinutes = days * 1440 // 1440 is minutes in a day
        const minutesTillEnd = differenceInMinutes(
          new Date(promoTier.value.expires),
          Date.now()
        )
        const purePercentage = 100 - (minutesTillEnd / totalMinutes) * 100
        if (purePercentage >= 3) {
          return purePercentage + '%'
        }
        // else return a hardcoded value in order to be visually ok
        return '2%'
      }
      return ''
    })

    return {
      paidCredits,
      ciCredit,
      expiresIn,
      expirePercentage,
      PromotedTier,
      costString,
      tierBadgeClasses,
      tierTextClass,
      tierBgClass
    }
  }
})
